































// @ is an alias to /src
import { Component, Vue } from "vue-property-decorator";
import { QRPass } from "@/lib/QRPass";
import moment from "moment";

interface ReasonType {
  value: string;
  text: string;
  duration: string;
}

const reasons = new Map<string, ReasonType>();

// @Component({
//   components: {
//     HelloWorld
//   }
// })
@Component
export default class Home extends Vue {
  firstName = localStorage.getItem("firstName") ?? "";
  lastName = localStorage.getItem("lastName") ?? "";
  idNumber = localStorage.getItem("idNumber") ?? "";
  reason = localStorage.getItem("reason") ?? "walking";
  date = localStorage.getItem("startDate") ?? new Date();
  time =
    localStorage.getItem("startTime") ??
    moment()
      .add(5, "m")
      .format("HH:mm");
  licensePlate = localStorage.getItem("licensePlate") ?? "";

  reasonOptions: any[] = [];

  showOverlay = false;

  created() {
    const rd = [
      ["shopping", "Shopping", "4h"],
      ["walking", "Walking", "2h"],
      ["dog_walk", "Dog walk", "2h"],
      ["medical", "Medical reasons", "12h"],
      ["work", "Go to work", "14d"]
    ];
    for (const d of rd) {
      const [value, text, duration] = d;
      console.log({ value, text, duration });
      this.reasonOptions.push({ value, text: `${text} (${duration})` });
      reasons.set(value, { value, text, duration });
    }
    console.log(this.reasonOptions);
  }

  mounted() {
    if (this.time.trim() == "") this.time = moment().format("HH:mm");
  }

  progressToast(text: string) {
    return this.$bvToast.toast(text, {
      // title: 'pleae wait',
      autoHideDelay: 5000,
      variant: "success",
      appendToast: true,
      noCloseButton: true,
      toaster: "b-toaster-bottom-left",
      noHoverPause: true
    });
  }

  get timestamp() {
    const tz = moment().format("Z");
    const correctedDate =
      this.date instanceof Date
        ? moment()
            .format()
            .split("T")[0]
        : this.date;
    console.log("fixing time for 24h again");
    let t = this.time;
    if (t[1] == ":") t = "0" + t;
    const stamp = `${correctedDate}T${t}${tz}`;
    console.log("recalculated timestamp " + stamp);
    return stamp;
  }

  get momentStamp(): moment.Moment {
    return moment(this.timestamp);
  }

  async doCreateQrPass(): Promise<boolean> {
    this.showOverlay = true;
    this.progressToast("Connecting to myonly.cloud...");
    try {
      console.log("retreiving service.");
      const service = await QRPass.instance.getService();
      console.log("get a service", service);
      this.progressToast("Creating QRPass..");
      console.log(
        "Creating the document, restored timestamp: " + this.timestamp
      );
      const qrpass = {
        type: "QRPass",
        version: "1.0",
        firstName: this.firstName,
        lastName: this.lastName,
        idNumber: this.idNumber,
        licensePlate: this.licensePlate,
        reason: reasons.get(this.reason),
        timestamp: this.timestamp
      };
      localStorage.setItem("firstName", this.firstName);
      localStorage.setItem("lastName", this.lastName);
      localStorage.setItem("idNumber", this.idNumber);
      localStorage.setItem("reason", this.reason);
      localStorage.setItem("licensePlate", this.licensePlate);
      console.log("document:", qrpass);
      QRPass.instance.createDocument(qrpass).then(d => {
        console.log("document creation done:", d);
        localStorage.setItem("lastQRCode", d);
        this.$router.push("/q");
        this.showOverlay = false;
      });
      return true;
    } catch (e) {
      this.$bvToast.toast(e.toLocaleString(), {
        title: "Error creating QRPass",
        autoHideDelay: 5000,
        variant: "danger",
        appendToast: true,
        noCloseButton: true,
        toaster: "b-toaster-bottom-left",
        noHoverPause: true
      });
      this.showOverlay = false;
      return false;
    }
  }

  get timestampOk() {
    console.log(
      "timestamp ok? ",
      this.momentStamp,
      this.momentStamp.isAfter(moment())
    );
    return this.momentStamp.isAfter(moment());
  }
  get dataOk(): boolean {
    return (
      this.firstName.trim().length > 0 &&
      this.lastName.trim().length > 0 &&
      this.idNumber.trim().length > 0 &&
      this.time.trim().length > 0 &&
      this.timestampOk
    );
  }

  createPass() {
    if (this.dataOk) this.doCreateQrPass();
  }
}
